'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'angle-90';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e08d';
var svgPathData = 'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 464c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 448 32 48zm160.8 75c-29.9-13.2-62.2-21.9-96-25.3c-9.1-.9-16.8 6.4-16.8 15.6c0 8.5 6.7 15.5 15.1 16.4c29.3 3.2 57.3 10.7 83.3 22c7.6 3.3 16.6 .8 21-6.3c4.9-8 2-18.5-6.6-22.3zM297.5 247.4c5.1 7.1 14.8 9.3 22.2 4.7c7.6-4.7 10-14.8 4.7-22.1c-20.6-28.8-45.8-54-74.6-74.6c-7.3-5.2-17.4-2.9-22.1 4.7c-4.6 7.4-2.3 17.1 4.7 22.2c24.9 18 46.9 40 64.9 64.9zm30.8 54.1c11.3 26 18.8 54 22 83.3c.9 8.5 7.9 15.1 16.4 15.1c9.2 0 16.5-7.7 15.6-16.8c-3.4-33.9-12.2-66.1-25.3-96c-3.8-8.6-14.3-11.6-22.3-6.6c-7.1 4.4-9.6 13.4-6.3 21z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAngle90 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;